import { ArrowRightIcon } from '@heroicons/react/20/solid';
import axios from 'axios';
import { type FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/Ui/Button';
import auth from '@/helpers/auth';

const ConfirmLoginPage = function () {
    const navigate = useNavigate();
    const [
        t,
    ] = useTranslation('pages');
    const [
        searchParams,
    ] = useSearchParams();
    const token = searchParams.get('token');

    const [
        code,
        setCode,
    ] = useState('');

    const confirm = async () => {
        await axios.post(`/api/auth/2fa/authenticate`, {
            code: code,
            token: token,
        }).then(({ data }) => {
            auth.setUser(data);

            navigate(auth.getInitialPath());
        }).catch(() => {
            setCode('');
            toast.error(t('Code incorrect, please try again'));
        });

        return false;
    };

    return (
        <div className='max-w-md'>
            <div className='text-center text-foreground'>
                <p className='font-bold text-xl'>{t('Confirm your login with 2fa')}</p>
                <p className='mt-4'>{t('Enter the 6-digits code from your Authenticator app.')}</p>
            </div>
            <form className='mt-8 space-y-6' onSubmit={ (e: FormEvent) => {
                e.preventDefault();

                return confirm();
            } }>
                <input defaultValue='true' name='remember' type='hidden' />
                <div className='-space-y-px rounded-md shadow-sm'>
                    <div>
                        <label className='sr-only' htmlFor='code'>
                            {t('Code')}
                        </label>
                        <input
                            className='relative block w-full appearance-none rounded-md border border-input px-3 py-2 text-foreground placeholder-muted-foreground focus:z-10 focus:border-primary focus:outline-none focus:ring-primary sm:text-sm'
                            id='code'
                            name='code'
                            onChange={ (e) => {
                                return setCode(e.target.value);
                            } }
                            placeholder={ t('Authentication code') }
                            required
                            type='code'
                            value={ code }
                        />
                    </div>
                </div>

                <Button
                    className='w-full'
                    type='submit'
                >
                    <ArrowRightIcon aria-hidden='true' className='h-5 w-5' />
                    {t('Confirm code')}
                </Button>
            </form>
        </div>
    );
};

export default ConfirmLoginPage;
